import React, { createContext } from "react";
import { ClinicConfig } from "fe-common/graphql/clinic/clinicTypes";
import {
  ConfigurationSettingListWithSource,
  MergedConfigurationSettings,
} from "@kahunmedical/common-configuration";
import { ClinicGeneralOptions } from "@kahunmedical/common-configuration/dist/configuration/clinic";

export interface ClinicShortCode {
  current: string;
  lastCreated: string;
  loading: boolean;
}

/***
 * Clinic object as stored in db
 */
export interface ClinicDaoData {
  clinic: string;
  name?: string;
  /***
   * @deprecated use ClinicContextData.settings instead
   */
  config?: ClinicConfig;
  mergedConfiguration?: ConfigurationSettingListWithSource;
  error?: boolean;
  errorText?: string;
}

export interface ClinicContextData extends ClinicDaoData {
  isClinicMode: boolean;
  loading?: boolean;
  settings?: MergedConfigurationSettings;
  clinicSettings?: ClinicGeneralOptions;
}

export const ClinicContext = createContext<ClinicContextData>(null);

export const ClinicDataContextProvider = ({
  value,
  children,
}: {
  value: ClinicContextData;
  children?: any;
}) => <ClinicContext.Provider value={value}>{children}</ClinicContext.Provider>;
